/* eslint-disable @typescript-eslint/prefer-ts-expect-error */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-console */

'use client'

import { useEffect } from 'react'
import { getPageType } from 'src/helpers/commonHelpers'
import useIdentifyEvent from '@hooks/useIdentityEvent'
import { lobSegmentEventProperties, segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { lobSegmentEvents, widgetJourney, widgetProduct } from '@configs/segmentEvents.config'

export function waitForAnalyticsLoad() {
  return new Promise(resolve => {
    const resolver = () => {
      if (window?.acko_analytics && window?.acko_analytics?.anonymousId !== undefined) {
        resolve(void 0)
      } else {
        window.setTimeout(resolver, 300)
      }
    }
    setTimeout(resolver, 300)
  })
}
const AnalyticsViewPage = ({ segmentEventCommonProperties, isSemPage = false, lob, reqCookie, widget }) => {
  useIdentifyEvent()
  useEffect(() => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      const viewEventName = lobSegmentEvents?.[getPageType(isSemPage)]?.[lob]?.pageView || 'view_seo_page'
      const widgetType = lobSegmentEvents?.[getPageType(isSemPage)]?.[lob]?.widgetType || 'SEO revamp widget'
      const product = widgetProduct?.[widget]?.()
      const journey = widgetJourney?.[widget]

      const additionalLobEventProperties = lobSegmentEventProperties[lob]?.(reqCookie, isSemPage) || {}

      waitForAnalyticsLoad()
        .then(() => {
          console.log(window?.acko_analytics?.anonymousId, isSemPage, ':::Analytics changes')
          pageEvent(viewEventName, {
            ...properties,
            ...(product && { product }),
            ...(journey && { journey }),
            ...additionalLobEventProperties,
            widget_type: widgetType,
            funnel: 'visit',
          })
        })
        .catch(err => {
          console.log('Wait for analytics load error', err)
        })
    })()
  }, [])

  return null
}

export default AnalyticsViewPage
